import { chargeAppliedBalance, chargeCash, noPaymentSelected } from 'api/Transaction';

import { requiredMsg } from 'lib/constants/messages';

import { showAlert } from 'components/shared/Alert/Alert';

export const chargeOutsideFinancingHandler = (
  navigate,
  {
    invoices,
    patientId,
    appointmentId,
    surchargeAmount,
    amount,
    appliedBalance,
    methodDetail,
    checkin,
    planId,
    scheduleId
  }
) => {
  if (!methodDetail) {
    showAlert({
      title: requiredMsg('Outside financing number'),
      color: 'danger'
    });
    return;
  }

  return chargeCash(navigate, {
    invoices,
    patientId,
    appointmentId,
    checkin,
    appliedBalance,
    planId,
    scheduleId,
    transaction: {
      surcharge_amount: surchargeAmount,
      amount: { value: amount, currency: 'USD' },
      note: `Outside Financing Number: ${methodDetail}`,
      type: 'care_credit'
    }
  });
};

export const chargeCheckHandler = (
  navigate,
  {
    invoices,
    patientId,
    appointmentId,
    surchargeAmount,
    amount,
    methodDetail,
    invoiceId,
    practiceId,
    checkin,
    appliedBalance,
    planId,
    scheduleId
  }
) => {
  if (!methodDetail) return;

  return chargeCash(navigate, {
    invoices,
    patientId,
    invoiceId,
    practiceId,
    appointmentId,
    checkin,
    appliedBalance,
    planId,
    scheduleId,
    transaction: {
      amount: { value: amount, currency: 'USD' },
      surcharge_amount: surchargeAmount,
      note: `Check Number: ${methodDetail}`,
      type: 'check'
    }
  });
};

export const chargeCashHandler = (
  navigate,
  {
    invoices,
    patientId,
    appointmentId,
    surchargeAmount,
    amount,
    invoiceId,
    practiceId,
    invoiceToken,
    payerId,
    checkin,
    appliedBalance,
    planId,
    scheduleId
  }
) => {
  return chargeCash(navigate, {
    invoices,
    patientId,
    invoiceId,
    practiceId,
    invoiceToken,
    appointmentId,
    surcharge_amount: surchargeAmount,
    checkin,
    planId,
    scheduleId,
    transaction: {
      appliedBalance,
      surcharge_amount: surchargeAmount,
      amount: { value: amount, currency: 'USD' },
      note: ``,
      type: 'cash',
      payer_id: payerId
    }
  });
};

export const noPaymentSelectedHandler = (navigate, { appointmentId }) => {
  return noPaymentSelected(navigate, { id: appointmentId });
};

export const appliedBalanceHandler = (
  navigate,
  { appliedBalance, amount, invoices, patientId, practiceId }
) => {
  return chargeAppliedBalance(navigate, {
    appliedBalance,
    amount,
    invoices,
    patientId,
    practiceId
  });
};
